export const plansDefaults = {
  basicPriceMonthly: 15,
  basicPriceYearly: 120,
  proPricePerMemberMonthly: 25,
  proPricePerMemberYearly: 20,
  basicPriceYearlyPerMonth: 10,
};
